module.exports = __webpack_public_path__ + "img/bofang-title.5223659a.png";